export enum ApiRequestStatus {
  NotSubmitted,
  InProgress,
  Success,
  Failed
}

export interface IApiRequestResult {
  status: ApiRequestStatus;
  errorCode?: string;
}
